import React from 'react';
import cx from '../../../styles';

const LoadMoreButton = (props) => {
    return (
        <div className={cx('load-more-post')}>
            <a href={`${props.slug}?page=${props.page + 1}`} onClick = {(e) => {e.preventDefault()}}>
                <spna>{props.t('load_more_posts')}</spna>
                { props.infiniteLoading && <span className={cx("spin-loader")} /> }    
            </a>
        </div>
    );
}

export default LoadMoreButton;
